import type {
  SortableUserColumn,
  UserLastLoginFilter,
  UserList,
  UserRole,
  UserStatus,
} from '../types'

import {
  sortableUserColumns,
  userLastLoginFilters,
  userListRoles,
  userLists,
  userRoles,
  userStatuses,
} from '../types'

export const isUserList = (value: string | undefined): value is UserList =>
  value !== undefined &&
  (Object.values(userLists) as readonly string[]).includes(value)

export const isUserStatus = (value: string): value is UserStatus =>
  (Object.values(userStatuses) as readonly string[]).includes(value)

export const isUserRole = (value: string): value is UserRole =>
  (Object.values(userRoles) as readonly string[]).includes(value)

export const isRoleOfList = (
  value: string,
  list: UserList
): value is UserRole =>
  (userListRoles[list] as readonly string[]).includes(value)

export const isUserLastLoginFilter = (
  value: string
): value is UserLastLoginFilter =>
  (Object.values(userLastLoginFilters) as readonly string[]).includes(value)

export const isSortableUserColumn = (
  column: string
): column is SortableUserColumn =>
  (sortableUserColumns as readonly string[]).includes(column)
